import * as Yup from "yup";

export const DropdownValidation = Yup.object()
  .shape({ label: Yup.string().required('Required'), value: Yup.string().required('Required') })
  .required('required')
  .nullable();
export const StringValidation = Yup.string().required();

export const PlanSchema = Yup.object().shape({
  name: StringValidation.label("Name"),
  // budget: StringValidation.label("Budget"),
  date: StringValidation.label("Date"),
  // status: DropdownValidation.label("Status"),
  // priority: DropdownValidation.label("Priority"),
  objective: Yup.object().shape({
        label: Yup.string().required("Required"),
        value: Yup.string().required("Required")
    }),
  // length: StringValidation.label("Length"),
});
